import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { WhatsAppCta } from '@/components/home/WhatsAppCta';
import { WA_MESSAGES } from '@/lib/whatsapp';
import { PACKAGES } from '@/lib/packages';
import { HOME } from '@/constants/testIds';

export const FloatingWhatsApp = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const isHome = ['/', '/index.html'].includes(pathname);
  useEffect(() => {
    setShow(false);
    if (!isHome) { const timer = setTimeout(() => setShow(true), 500); return () => clearTimeout(timer); }
    const hero = document.getElementById('top');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => setShow(!entry.isIntersecting), { threshold: 0 });
    observer.observe(hero);
    return () => observer.disconnect();
  }, [isHome]);
  if (!show) return null;
  return <>
    {isHome && <div className="gg-mobile-contactbar" data-testid="mobile-booking-bar"><div data-testid="mobile-booking-price"><small>Pakej CCTV dari</small><strong>{PACKAGES[0].price}</strong></div><WhatsAppCta testId="mobile-sticky-whatsapp-cta">WhatsApp · Site Visit</WhatsAppCta></div>}
    <div className={`fixed right-5 bottom-5 z-40 ${isHome ? 'hidden md:block' : ''}`}><WhatsAppCta testId={HOME.floatingWhatsappButton} message={WA_MESSAGES.general} className="rounded-full shadow-lg">WhatsApp Kami</WhatsAppCta></div>
  </>;
};

export default FloatingWhatsApp;